import {Component, Input, OnInit} from '@angular/core';
import {CesiumAdapterService} from '../../services/cesiumAdapter21/cesium-adapter.service';
import {saveAs} from 'file-saver';
import {EsBsModalService} from '../../services/bsModalService/bs-modal.service';
import {Subscription} from 'rxjs';
import {UiAdapterService} from 'src/app/services/uiAdapterService/ui-adapter.service';
import {debounceTime, last} from "rxjs/operators";
import {StoryService} from "../../services/storyService/story.service";
import {Story} from "../../models/Story/Story";
import {Slide} from "../../models/Story/Slide";
import {HttpClient} from "@angular/common/http";
import { EventService } from '@src/app/core/services/event.service';

@Component({
  selector: 'app-global-screenshot',
  templateUrl: './global-screenshot.component.html',
  styleUrls: ['./global-screenshot.component.scss']
})
export class GlobalScreenshotComponent implements OnInit {

  public Yiit = Yiit;
  private confirmSubscriber;
  private downloadSubscriber;
  private subscribers: Subscription = new Subscription();
  public isScreenshotCreated = false;
  public isStoriesAvailable = window['STORIES_ALLOWED'];
  public isLinkShareView: boolean;

  @Input() parent: any = false;

  get globalScreenShotHint(): string {
    if (this.isLinkShareView) {
      return 'Create an account to export hi-res screenshots of the event plan';
    }

    return (this.uiAdapterService.globalScreenshotEnabled)
      ? Yiit.t('Take Screenshot / Create Presentation for export')
      : Yiit.t('Under construction');
  }

  constructor(
    private cesiumAdapterService: CesiumAdapterService,
    private bsModal: EsBsModalService,
    private uiAdapterService: UiAdapterService,
    private httpClient: HttpClient,
    private storyAdapter: StoryService,
    private eventService: EventService,
  ) {
    this.isScreenshotCreated = this.storyAdapter.stories.length > 0;

    this.storyAdapter.storiesUpdated$.subscribe((stories:Story[])=>{
      this.isScreenshotCreated = stories.length > 0;
    });
  }

  ngOnInit(): void {
    this.isLinkShareView = this.eventService.isLinkShare;
  }

  screenshotClipboard() {

    if(this.parent){
      this.parent.closeMenu();
    }

    if (!this.uiAdapterService.globalScreenshotEnabled) {
      console.log('globalScreenshot is not enabled');
      return;
    }

    // this.cesiumAdapterService.setCursorStyle('wait');
    this.cesiumAdapterService.createScreenshotBlob().then(({blob, base64}) => {
      this.storyAdapter.setCurrentImage(base64);
      try {
        if (this.confirmSubscriber) {
          this.confirmSubscriber.unsubscribe();
        }
        if (this.downloadSubscriber) {
          this.downloadSubscriber.unsubscribe();
        }
        if (!this.isImageClipboardSupported()) {

        } else {
          // @ts-ignore
          if (ClipboardItem) {
            // @ts-ignore
            let item = new ClipboardItem({
              'image/png': blob
            });
            // @ts-ignore
            navigator.clipboard.write([item]);
          }
        }

        this.bsModal.currentModal = '#download-modal';
        this.bsModal.openModal();
        this.confirmSubscriber = this.bsModal.onModalFiresEvent$.subscribe(async (config)=>{
          if (config.hasOwnProperty('download')){
            let currentSlide = new Slide('Slide', 1);
            await this.storyAdapter.setSlideConfig(currentSlide);

            console.log(' JSON.stringify(currentSlide)',  JSON.stringify(currentSlide));

            this.httpClient.post('/story/generate-slide', {
              slide: JSON.stringify(currentSlide),
              event_id: window['EVENT_ID'],
            }).subscribe((result)=>{
              this.bsModal.currentModal = '#email-sending-confirm-modal';
              this.bsModal.openModal();
            });
            // let resultFlag = config.download;
            // if (resultFlag){
            //   this.screenshotDownload(blob);
            // }
            this.bsModal.closeModal();
            this.confirmSubscriber.unsubscribe();
          }
        });
      } catch (error) {
        console.error(error);
      }
    });
  }

  screenshotDownload(pngImageBlob) {
      try {
        saveAs(pngImageBlob, window['EVENT_CONFIG']['name'] + ' ' + (new Date()).toLocaleString() + '.png');
      } catch (error) {
        console.error(error);
      }
  }

  isImageClipboardSupported(): boolean {
    // @ts-ignore
    return (typeof(ClipboardItem) != "undefined");
  }

  toggleStoriesTab(){
    console.log('click');
    this.storyAdapter.toggleStoriesTab();
    if(this.parent){
      this.parent.closeMenu();
    }
  }

  isDisabled(): boolean {
    return this.uiAdapterService.globalScreenshotEnabled
      ? this.isImageClipboardSupported()
      : true;
  }
}
